export const BANK_TYPE_RECIPIENT = 'recipient'
export const BANK_TYPE_SENDER = 'sender'
